let page_schema = {
    "tiers": [
      {
        "name": "Sample Type",
        "type": "checkbox",
        "id": "sample-types",
        "class_name": "tags",
        "child_name": "sample-type",
        "options": [
          {
            "name": "All-Purpose Extraction",
            "id": "all-purpose-extraction"
          },
          {
            "name": "Bacteria",
            "id": "bacteria"
          },
          {
            "name": "Biological Fluids (CSF, Amniotic Fluid, Serum, Plasma, etc. )",
            "id": "biological-fluids"
          },
          {
            "name": "Blood",
            "id": "blood"
          },
          {
            "name": "Cells",
            "id": "cells"
          },
          {
            "name": "Feces",
            "id": "feces"
          },
          {
            "name": "FFPE Tissue",
            "id": "ffpe"
          },
          {
            "name": "Insect",
            "id": "insect"
          },
          {
            "name": "Microbial Cultures",
            "id": "microbial-cultures"
          },
          {
            "name": "Plant/Seed",
            "id": "plant-seed"
          },
          {
            "name": "Slide",
            "id": "slide"
          },
          {
            "name": "Soil & Water",
            "id": "soil-and-water"
          },
          {
            "name": "Storage Papers, Hair, Feather, Nails",
            "id": "storage-papers-hair-feather-nails"
          },
          {
            "name": "Swabs & Saliva",
            "id": "swabs-and-saliva"
          },
          {
            "name": "Tissue",
            "id": "tissue"
          },
          // {
          //   "name": "FFPE Tissue",
          //   "id": "ffpe-tissue"
          // },
          {
            "name": "Urine",
            "id": "urine"
          },
          {
            "name": "Virus",
            "id": "virus"
          },
          {
            "name": "Yeast/Fungi",
            "id": "yeast-fungi"
          }
        ]
      },
      {
        "name": "Features",
        "type": "checkbox",
        "id": "features",
        "class_name": "tags",
        "child_name": "feature",
        "options": [
          {
            "name": "CE-IVD",
            "id": "ce-ivd"
          },
          {
            "name": "Cell-Free DNA",
            "id": "cell-free-dna"
          },
          {
            "name": "Certified Low Bioburden",
            "id": "certified-low-bioburden"
          },
          {
            "name": "High Sample Input",
            "id": "high-sample-input"
          },
          {
            "name": "High-Throughput",
            "id": "high-throughput"
          },
          {
            "name": "HMW DNA",
            "id": "hmw-dna"
          },
          {
            "name": "Host DNA Depletion",
            "id": "host-dna-depletion"
          },
          {
            "name": "Isolate DNA > 100 kb",
            "id": "isolate-dna-gt-100-kb"
          },
          {
            "name": "Isolate DNA > 50 kb",
            "id": "isolate-dna-gt-50-kb"
          },
          {
            "name": "Low Sample Input",
            "id": "low-sample-input"
          },
          {
            "name": "Microbiome/ Metagenome Analysis",
            "id": "microbiome-metagenome-analysis"
          },
          {
            "name": "Nucleosomal DNA Isolation",
            "id": "nucleosomal-dna-isolation"
          },
          {
            "name": "Physical Lysis",
            "id": "physical-lysis"
          },
          {
            "name": "Proteinase K Included",
            "id": "proteinase-k-included"
          },
          {
            "name": "Zymolyase Included",
            "id": "zymolyase-included"
          }
        ]
      },
      {
        "name": "Formats",
        "type": "checkbox",
        "id": "formats",
        "class_name": "tags",
        "child_name": "format",
        "options": [
          {
            "name": "Spin Columns",
            "id": "spin-columns"
          },
          {
            "name": "96-Well Plate",
            "id": "96-well-plate"
          },
          {
            "name": "Magnetic Beads (Automatable)",
            "id": "magnetic-beads"
          }
        ]
      },
      {
        "name": "PreFilters",
        "type": "checkbox",
        "id": "prefilters",
        "class_name": "tags",
        "child_name": "prefilter",
        "options": [
          {
            "name": "Quick DNA Extraction Kits",
            "id": "quick-dna-extraction-kits"
          },
          {
            "name": "Microbial & Environmental",
            "id": "microbial-environmental"
          }
        ]
      },
      {
        "name": "d-none",
        "type": "checkbox",
        "id": "d-none",
        "class_name": "tags",
        "child_name": "d-none",
        "options": [
          {
            "name": "Automated & High-Throughput",
            "id": "automated-high-throughput",
          }
        ]
      }
    ],
    "filters": [],
    "products": {
      "Quick-DNA Miniprep Plus Kit": {
        "title": "<i>Quick</i>-DNA Miniprep Plus Kit",
        "catalogNumbers": "D4068, D4068T, D4069",
        "description": "Recover high yields of total DNA in just 35 µl from cells, tissues, and any biological fluid in only 20 minutes.",
        "handle": "/products/quick-dna-miniprep-plus-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4068.jpg",
        "generalIndex": "4",
        "id": "quick-dna-miniprep-plus-kit",
        "tags": [
          "all-purpose-extraction",
          "blood",
          "cells",
          "tissue",
          "biological-fluids",
          "swabs-and-saliva",
          "virus",
          "storage-papers-hair-feather-nails",
          "proteinase-k-included",
          "hmw-dna",
          "spin-columns",
          "isolate-dna-gt-50-kb",
          "quick-dna-extraction-kits"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 2
          // },
          // {
          //   "filter": "hmw-dna",
          //   "index": 2
          // }
        ]
      },
      "Quick-DNA Microprep Plus Kit": {
        "title": "<i>Quick</i>-DNA Microprep Plus Kit",
        "catalogNumbers": "D4074",
        "description": "Recover high yields of total DNA in just 10 µl from cells, tissues, and any biological fluid in only 20 minutes.",
        "handle": "/products/quick-dna-microprep-plus-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4074.jpg",
        "generalIndex": "3",
        "id": "quick-dna-microprep-plus-kit",
        "tags": [
          "all-purpose-extraction",
          "blood",
          "cells",
          "tissue",
          "biological-fluids",
          "swabs-and-saliva",
          "virus",
          "storage-papers-hair-feather-nails",
          "low-sample-input",
          "proteinase-k-included",
          "hmw-dna",
          "spin-columns",
          "isolate-dna-gt-50-kb",
          "quick-dna-extraction-kits"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 1
          // },
          // {
          //   "filter": "hmw-dna",
          //   "index": 1
          // }
        ]
      },
      "Quick-DNA Midiprep Plus Kit": {
        "title": "<i>Quick</i>-DNA Midiprep Plus Kit",
        "catalogNumbers": "D4075",
        "description": "Isolate ultra-pure total DNA from high inputs of cells, tissues, and any biological fluid using a fast spin-column protocol.",
        "handle": "/products/quick-dna-midiprep-plus-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4075.jpg",
        "generalIndex": "5",
        "id": "quick-dna-midiprep-plus-kit",
        "tags": [
          "all-purpose-extraction",
          "blood",
          "cells",
          "tissue",
          "biological-fluids",
          "swabs-and-saliva",
          "virus",
          "storage-papers-hair-feather-nails",
          "high-sample-input",
          "proteinase-k-included",
          "hmw-dna",
          "spin-columns",
          "isolate-dna-gt-50-kb",
          "quick-dna-extraction-kits"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 3
          // },
          // {
          //   "filter": "hmw-dna",
          //   "index": 3
          // }
        ]
      },
      "Quick-DNA Magbead Plus Kit": {
        "title": "<i>Quick</i>-DNA Magbead Plus Kit",
        "catalogNumbers": "D4081, D4082",
        "description": "Automatable purification of high-quality total DNA from cells, tissues, and any biological fluid.",
        "handle": "/products/quick-dna-magbead-plus-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4081.jpg",
        "generalIndex": "7",
        "id": "quick-dna-magbead-plus-kit",
        "tags": [
          "all-purpose-extraction",
          "blood",
          "cells",
          "tissue",
          "biological-fluids",
          "swabs-and-saliva",
          "virus",
          "storage-papers-hair-feather-nails",
          "high-throughput",
          "automated-high-throughput",
          "proteinase-k-included",
          "hmw-dna",
          "magnetic-beads",
          "isolate-dna-gt-50-kb",
          "isolate-dna-gt-100-kb",
          "quick-dna-extraction-kits"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 5
          // },
          // {
          //   "filter": "hmw-dna",
          //   "index": 5
          // },
          // {
          //   "filter": "high-throughput",
          //   "index": 1
          // }
        ]
      },
      "Quick-DNA 96 Plus Kit": {
        "title": "<i>Quick</i>-DNA 96 Plus Kit",
        "catalogNumbers": "D4070, D4071",
        "description": "High-throughput purification of high-quality total DNA from cells, tissues, and any biological fluid.",
        "handle": "/products/quick-dna-96-plus-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4071.jpg",
        "generalIndex": "6",
        "id": "quick-dna-96-plus-kit",
        "tags": [
          "all-purpose-extraction",
          "blood",
          "cells",
          "tissue",
          "biological-fluids",
          "swabs-and-saliva",
          "virus",
          "storage-papers-hair-feather-nails",
          "high-throughput",
          "automated-high-throughput",
          "proteinase-k-included",
          "hmw-dna",
          "96-well-plate",
          "isolate-dna-gt-50-kb",
          "quick-dna-extraction-kits"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 4
          // },
          // {
          //   "filter": "hmw-dna",
          //   "index": 4
          // },
          // {
          //   "filter": "high-throughput",
          //   "index": 0
          // }
        ]
      },
      "Quick-DNA Fungal/Bacterial Microprep Kit": {
        "title": "<i>Quick</i>-DNA Fungal/Bacterial Microprep Kit",
        "catalogNumbers": "D6007",
        "description": "Simple and rapid isolation of ultra-pure DNA from up to 20 mg of tough-to-lyse fungi, Gram (+/-) bacteria, algae, and protozoa.",
        "handle": "/products/quick-dna-fungal-bacterial-microprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6007.jpg",
        "generalIndex": "12",
        "id": "quick-dna-fungal-bacterial-microprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "yeast-fungi",
          "low-sample-input",
          "physical-lysis",
          "spin-columns",
          "microbiome-metagenome-analysis",
          "microbial-environmental"
        ],
        "filters": []
      },
      "Quick-DNA Fungal/Bacterial Miniprep Kit": {
        "title": "<i>Quick</i>-DNA Fungal/Bacterial Miniprep Kit",
        "catalogNumbers": "D6005",
        "description": "Simple and rapid isolation of ultra-pure DNA from up to 100 mg of tough-to-lyse fungi, Gram (+/-) bacteria, algae, and protozoa.",
        "handle": "/products/quick-dna-fungal-bacterial-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6005.jpg",
        "generalIndex": "13",
        "id": "quick-dna-fungal-bacterial-miniprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "yeast-fungi",
          "physical-lysis",
          "spin-columns",
          "microbiome-metagenome-analysis",
          "microbial-environmental"
        ],
        "filters": []
      },
      "Quick-DNA Fungal/Bacterial Midiprep Kit": {
        "title": "<i>Quick</i>-DNA Fungal/Bacterial Midiprep Kit",
        "catalogNumbers": "D6105",
        "description": "Simple and rapid isolation of ultra-pure DNA from up to 500 mg of tough-to-lyse fungi, Gram (+/-) bacteria, algae, and protozoa.",
        "handle": "/products/quick-dna-fungal-bacterial-midiprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6105.jpg",
        "generalIndex": "14",
        "id": "quick-dna-fungal-bacterial-midiprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "yeast-fungi",
          "high-sample-input",
          "physical-lysis",
          "spin-columns",
          "microbiome-metagenome-analysis",
          "microbial-environmental"
        ],
        "filters": []
      },
      "Quick-DNA Fungal/Bacterial 96 Kit": {
        "title": "<i>Quick</i>-DNA Fungal/Bacterial 96 Kit",
        "catalogNumbers": "D6006",
        "description": "Simple high-throughput isolation of ultra-pure DNA from tough-to-lyse fungi, Gram (+/-) bacteria, algae, and protozoa.",
        "handle": "/products/quick-dna-fungal-bacterial-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6006.jpg",
        "generalIndex": "15",
        "id": "quick-dna-fungal-bacterial-96-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "yeast-fungi",
          "high-throughput",
          "automated-high-throughput",
          "physical-lysis",
          "96-well-plate",
          "microbiome-metagenome-analysis",
          "microbial-environmental"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 5
          // }
        ]
      },
      "ZymoBIOMICs DNA Miniprep Kit": {
        "title": "ZymoBIOMICS DNA Miniprep Kit",
        "catalogNumbers": "D4300, D4300T, D4304",
        "description": "Efficient microbial DNA purification from a variety of sample inputs for highly accurate microbiome and metagenome analyses.",
        "handle": "/products/zymobiomics-dna-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4300T.jpg",
        "generalIndex": "9",
        "id": "zymobiomics-dna-miniprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "biological-fluids",
          "soil-and-water",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "microbiome-metagenome-analysis",
          "physical-lysis",
          "spin-columns",
          "microbial-environmental",
          "cells",
          "certified-low-bioburden"
        ],
        "filters": []
      },
      "ZymoBIOMICS Microprep Kit (Lysis Tubes)": {
        "title": "ZymoBIOMICS DNA Microprep Kit",
        "catalogNumbers": "D4301, D4305",
        "description": "Efficient microbial DNA purification from low sample inputs for highly accurate microbiome and metagenome analyses.",
        "handle": "/products/zymobiomics-dna-microprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4301.jpg",
        "generalIndex": "8",
        "id": "zymobiomics-dna-microprep-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "biological-fluids",
          "soil-and-water",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "low-sample-input",
          "microbiome-metagenome-analysis",
          "physical-lysis",
          "spin-columns",
          "microbial-environmental",
          "cells",
          "certified-low-bioburden"
        ],
        "filters": []
      },
      "ZymoBIOMICS 96 MagBead DNA Kit": {
        "title": "ZymoBIOMICS 96 MagBead DNA Kit",
        "catalogNumbers": "D4302, D4302-E, D4306, D4306-E, D4308, D4308-E",
        "description": "Automatable solution for microbial DNA purification from a variety of sample inputs for highly accurate microbiome and metagenome analyses.",
        "handle": "/products/zymobiomics-96-magbead-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4302.jpg",
        "generalIndex": "11",
        "id": "zymobiomics-96-magbead-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "biological-fluids",
          "soil-and-water",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "ce-ivd",
          "high-throughput",
          "automated-high-throughput",
          "microbiome-metagenome-analysis",
          "physical-lysis",
          "magnetic-beads",
          "microbial-environmental",
          "certified-low-bioburden",
          "cells",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 4
          // }
        ]
      },
      "ZymoBIOMICS 96 DNA Kit": {
        "title": "ZymoBIOMICS 96 DNA Kit",
        "catalogNumbers": "D4303, D4307, D4309",
        "description": "High-throughput microbial DNA purification from a variety of sample inputs for highly accurate microbiome and metagenome analyses.",
        "handle": "/products/zymobiomics-96-dna-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4303.jpg",
        "generalIndex": "10",
        "id": "zymobiomics-96-dna-kit",
        "tags": [
          "microbial-cultures",
          "bacteria",
          "blood",
          "tissue",
          "feces",
          "biological-fluids",
          "soil-and-water",
          "swabs-and-saliva",
          "urine",
          "virus",
          "yeast-fungi",
          "high-throughput",
          "automated-high-throughput",
          "microbiome-metagenome-analysis",
          "physical-lysis",
          "96-well-plate",
          "microbial-environmental",
          "cells",
          "certified-low-bioburden"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 3
          // }
        ]
      },
      // "ZymoBIOMICS DNA/RNA Miniprep Kit": {
      //   "title": "ZymoBIOMICS DNA/RNA Miniprep Kit",
      //   "catalogNumbers": "R2002",
      //   "description": "Designed for purifying DNA and RNA from a wide array of sample inputs (e.g. feces, soil, plant, water, and biofilms). Ready for RT-PCR, arrays, sequencing, microbiome or metagenome analysis.",
      //   "handle": "/products/zymobiomics-dna-rna-miniprep-kit",
      //   "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg?v=1628532356&width=600",
      //   "generalIndex": "998",
      //   "id": "zymobiomics-dna-rna-miniprep-kit",
      //   "tags": [
      //     "microbial-cultures",
      //     "bacteria",
      //     "blood",
      //     "tissue",
      //     "feces",
      //     "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
      //     "soil-and-water",
      //     "swabs-and-saliva",
      //     "urine",
      //     "virus",
      //     "yeast-fungi",
      //     "microbiome-metagenome-analysis",
      //     "physical-lysis",
      //     "total-nucleic-acid-dna-rna-purification",
      //     "spin-columns",
      //     "cells",
      //     "certified-low-bioburden"
      //   ],
      //   "filters": []
      // },
      // "ZymoBIOMICS MagBead DNA/RNA": {
      //   "title": "ZymoBIOMICS MagBead DNA/RNA",
      //   "catalogNumbers": "R2135, R2136",
      //   "description": "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
      //   "handle": "/products/zymobiomics-magbead-dna-rna",
      //   "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r2135_zymobiomics_96_magbead_dna_rna_kit.png?v=1628532421&width=600",
      //   "generalIndex": "998",
      //   "id": "zymobiomics-magbead-dna-rna",
      //   "tags": [
      //     "microbial-cultures",
      //     "bacteria",
      //     "blood",
      //     "tissue",
      //     "feces",
      //     "biological-fluids-csf-amniotic-fluid-serum-plasma-etc",
      //     "soil-and-water",
      //     "swabs-and-saliva",
      //     "urine",
      //     "virus",
      //     "yeast-fungi",
      //     "high-throughput",
      //     "microbiome-metagenome-analysis",
      //     "proteinase-k-included",
      //     "physical-lysis",
      //     "total-nucleic-acid-dna-rna-purification",
      //     "magnetic-beads-automatable",
      //     "cells",
      //     "certified-low-bioburden"
      //   ],
      //   "filters": []
      // },
      "Quick-DNA Fecal/Soil Microbe DNA Miniprep Kit": {
        "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Miniprep Kit",
        "catalogNumbers": "D6010",
        "description": "Robust spin-column extraction of ultra-pure total microbial DNA from up to 150 mg of feces or 250 mg of soil.",
        "handle": "/products/quick-dna-fecal-soil-microbe-dna-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6010.jpg",
        "generalIndex": "17",
        "id": "quick-dna-fecal-soil-microbe-dna-miniprep-kit",
        "tags": [
          "bacteria",
          "feces",
          "soil-and-water",
          "virus",
          "yeast-fungi",
          "physical-lysis",
          "spin-columns",
          "microbiome-metagenome-analysis",
          "microbial-environmental"
        ],
        "filters": []
      },
      "Quick-DNA Fecal/Soil Microbe Microprep": {
        "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Microprep Kit",
        "catalogNumbers": "D6012",
        "description": "Robust spin-column extraction of ultra-pure total microbial DNA from up to 50 mg of feces or 250 mg of soil.",
        "handle": "/products/quick-dna-fecal-soil-microbe-microprep",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6012.jpg",
        "generalIndex": "16",
        "id": "quick-dna-fecal-soil-microbe-microprep",
        "tags": [
          "bacteria",
          "feces",
          "soil-and-water",
          "virus",
          "yeast-fungi",
          "low-sample-input",
          "physical-lysis",
          "spin-columns",
          "microbiome-metagenome-analysis",
          "microbial-environmental"
        ],
        "filters": []
      },
      "Quick-DNA Fecal/Soil Microbe 96 Magbead Kit": {
        "title": "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Magbead Kit",
        "catalogNumbers": "D6010-FM, D6011-FM, D6012-FM",
        "description": "Robust automatable extraction of ultra-pure total microbial DNA from up to 100 mg of feces or 200 mg of soil.",
        "handle": "/products/quick-dna-fecal-soil-microbe-96-magbead-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6011_FM.jpg",
        "generalIndex": "20",
        "id": "quick-dna-fecal-soil-microbe-96-magbead-kit",
        "tags": [
          "bacteria",
          "feces",
          "soil-and-water",
          "virus",
          "yeast-fungi",
          "high-throughput",
          "automated-high-throughput",
          "physical-lysis",
          "magnetic-beads",
          "microbial-environmental",
          "microbiome-metagenome-analysis",
          "96-well-plate"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 7
          // }
        ]
      },
      "Quick-DNA Fecal/Soil Microbe 96 Kit": {
        "title": "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Kit",
        "catalogNumbers": "D6011",
        "description": "Robust high-throughput extraction of ultra-pure total microbial DNA from up to 80 mg of feces or 135 mg of soil.",
        "handle": "/products/quick-dna-fecal-soil-microbe-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6011.jpg",
        "generalIndex": "19",
        "id": "quick-dna-fecal-soil-microbe-96-kit",
        "tags": [
          "bacteria",
          "feces",
          "soil-and-water",
          "virus",
          "yeast-fungi",
          "high-throughput",
          "automated-high-throughput",
          "physical-lysis",
          "96-well-plate",
          "microbiome-metagenome-analysis",
          "microbial-environmental"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 6
          // }
        ]
      },
      "Quick-DNA Fecal/Soil Microbe Midiprep": {
        "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Midiprep Kit",
        "catalogNumbers": "D6110",
        "description": "Robust spin-column extraction of ultra-pure total microbial DNA from up to 375 mg of feces or 5 grams of soil.",
        "handle": "/products/quick-dna-fecal-soil-microbe-midiprep",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6110.jpg",
        "generalIndex": "18",
        "id": "quick-dna-fecal-soil-microbe-midiprep",
        "tags": [
          "bacteria",
          "feces",
          "soil-and-water",
          "virus",
          "yeast-fungi",
          "physical-lysis",
          "spin-columns",
          "microbiome-metagenome-analysis",
          "microbial-environmental",
          "high-sample-input"
        ],
        "filters": []
      },
      "Quick-DNA Miniprep Kit": {
        "title": "<i>Quick</i>-DNA Miniprep Kit",
        "catalogNumbers": "D3024, D3025",
        "description": "Fast and easy Proteinase K-free extraction of ultra-pure total DNA from up to 200 µl of blood or 5 x 10^6 cells.",
        "handle": "/products/quick-dna-miniprep",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3024.jpg",
        "generalIndex": "34",
        "id": "quick-dna-miniprep",
        "tags": [
          "cells",
          "biological-fluids",
          "virus",
          "hmw-dna",
          "spin-columns",
          "swabs-and-saliva",
          "blood",
          "isolate-dna-gt-50-kb",
          "quick-dna-extraction-kits"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 9
          // },
          // {
          //   "filter": "hmw-dna",
          //   "index": 7
          // }
        ]
      },
      "Quick-DNA Microprep Kit": {
        "title": "<i>Quick</i>-DNA Microprep Kit",
        "catalogNumbers": "D3020, D3021",
        "description": "Fast and easy Proteinase K-free extraction of ultra-pure total DNA from up to 50 µl of blood or 1 x 10^6 cells.",
        "handle": "/products/quick-dna-microprep",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3021.jpg",
        "generalIndex": "33",
        "id": "quick-dna-microprep",
        "tags": [
          "cells",
          "biological-fluids",
          "virus",
          "low-sample-input",
          "hmw-dna",
          "swabs-and-saliva",
          "spin-columns",
          "blood",
          "isolate-dna-gt-50-kb",
          "quick-dna-extraction-kits"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 8
          // },
          // {
          //   "filter": "hmw-dna",
          //   "index": 6
          // }
        ]
      },
      "Quick-DNA 96 Kit": {
        "title": "<i>Quick</i>-DNA 96 Kit",
        "catalogNumbers": "D3010, D3011, D3012",
        "description": "High-throughput Proteinase K-free extraction of ultra-pure total DNA from 50 µl of blood or 1 x 10^6 cells.",
        "handle": "/products/quick-dna-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3012.jpg",
        "generalIndex": "35",
        "id": "quick-dna-96-kit",
        "tags": [
          "cells",
          "biological-fluids",
          "virus",
          "high-throughput",
          "automated-high-throughput",
          "hmw-dna",
          "swabs-and-saliva",
          "96-well-plate",
          "blood",
          "isolate-dna-gt-50-kb",
          "quick-dna-extraction-kits"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 10
          // },
          // {
          //   "filter": "hmw-dna",
          //   "index": 8
          // },
          // {
          //   "filter": "high-throughput",
          //   "index": 2
          // }
        ]
      },
      "Quick-DNA Tissue/Insect Microprep Kit": {
        "title": "<i>Quick</i>-DNA Tissue/Insect Microprep Kit",
        "catalogNumbers": "D6015",
        "description": "Simply extract high quality DNA from up to 10 mg of tissue or insect specimens using rapid spin-column purification.",
        "handle": "/products/quick-dna-tissue-insect-microprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6015.jpg",
        "generalIndex": "26",
        "id": "quick-dna-tissue-insect-microprep-kit",
        "tags": [
          "tissue",
          "insect",
          "virus",
          "low-sample-input",
          "physical-lysis",
          "spin-columns",
          "microbial-environmental"
        ],
        "filters": []
      },
      "Quick-DNA Tissue/Insect Miniprep Kit": {
        "title": "<i>Quick</i>-DNA Tissue/Insect Miniprep Kit",
        "catalogNumbers": "D6016",
        "description": "Simply extract high quality DNA from up to 50 mg of tissue or insect specimens using rapid spin-column purification.",
        "handle": "/products/quick-dna-tissue-insect-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6016.jpg",
        "generalIndex": "27",
        "id": "quick-dna-tissue-insect-miniprep-kit",
        "tags": [
          "tissue",
          "insect",
          "virus",
          "physical-lysis",
          "spin-columns",
          "microbial-environmental"
        ],
        "filters": []
      },
      "Quick-DNA Tissue/Insect 96 Kit": {
        "title": "<i>Quick</i>-DNA Tissue/Insect 96 Kit",
        "catalogNumbers": "D6017",
        "description": "Simple high-throughput spin-column purification of high quality DNA from up to 10 mg of tissue or insect specimens.",
        "handle": "/products/quick-dna-tissue-insect-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/Insect_96_Kit.jpg",
        "generalIndex": "28",
        "id": "quick-dna-tissue-insect-96-kit",
        "tags": [
          "tissue",
          "insect",
          "virus",
          "high-throughput",
          "automated-high-throughput",
          "physical-lysis",
          "96-well-plate",
          "microbial-environmental"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 11
          // }
        ]
      },
      "Quick-DNA Plant/Seed Miniprep Kit": {
        "title": "<i>Quick</i>-DNA Plant/Seed Miniprep Kit",
        "catalogNumbers": "D6020",
        "description": "Efficiently recover high-quality DNA free of PCR inhibitors from tough-to-lyse plant and seed samples.",
        "handle": "/products/quick-dna-plant-seed-miniprep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6020.jpg",
        "generalIndex": "24",
        "id": "quick-dna-plant-seed-miniprep-kit",
        "tags": [
          "plant-seed",
          "physical-lysis",
          "spin-columns",
          "microbial-environmental"
        ],
        "filters": []
      },
      "Quick-DNA Plant/Seed 96 Kit": {
        "title": "<i>Quick</i>-DNA Plant/Seed 96 Kit",
        "catalogNumbers": "D6021",
        "description": "High-throughput isolation of high-quality DNA free of PCR inhibitors from tough-to-lyse plant and seed samples.",
        "handle": "/products/quick-dna-plant-seed-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6021.jpg",
        "generalIndex": "25",
        "id": "quick-dna-plant-seed-96-kit",
        "tags": [
          "plant-seed",
          "high-throughput",
          "automated-high-throughput",
          "physical-lysis",
          "96-well-plate",
          "microbial-environmental"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 12
          // }
        ]
      },
      "MAGicBead cfDNA Isolation Kit": {
        "title": "MAGicBead cfDNA Isolation Kit",
        "catalogNumbers": "D4086, D4086-custom",
        "description": "Unique, magnetic bead surface chemistry that facilitates unparalleled cfDNA recovery from biofluids.",
        "handle": "/products/magicbead-cfdna-isolation-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4086.jpg",
        "generalIndex": "21",
        "id": "magicbead-cfdna-isolation-kit",
        "tags": [
          "biological-fluids",
          "swabs-and-saliva",
          "urine",
          "high-throughput",
          "automated-high-throughput",
          "proteinase-k-included",
          "cell-free-dna",
          "magnetic-beads"
        ],
        "filters": [
          {
            "filter": "cell-free-dna",
            "index": 0
          },
          // {
          //   "filter": "high-throughput",
          //   "index": 8
          // }
        ]
      },
      "Quick-DNA HMW MagBead Kit": {
        "title": "<i>Quick</i>-DNA HMW MagBead Kit",
        "catalogNumbers": "D6060",
        "description": "Extract ultra-pure high molecular weight DNA up to 150 kb from a variety of sample inputs using magnetic beads.",
        "handle": "/products/quick-dna-hmw-magbead-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6060.jpg",
        "generalIndex": "22",
        "id": "quick-dna-hmw-magbead-kit",
        "tags": [
          "blood",
          "cells",
          "tissue",
          "biological-fluids",
          "high-throughput",
          "automated-high-throughput",
          "proteinase-k-included",
          "hmw-dna",
          "magnetic-beads",
          "isolate-dna-gt-100-kb",
          "quick-dna-extraction-kits"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 100
          // },
          // {
          //   "filter": "hmw-dna",
          //   "index": 0
          // },
          // {
          //   "filter": "high-throughput",
          //   "index": 9
          // }
        ]
      },
      "Quick-DNA Viral Kit": {
        "title": "<i>Quick</i>-DNA Viral Kit",
        "catalogNumbers": "D3015, D3016",
        "description": "Quickly recover highly concentrated ultra-pure viral DNA from a wide range of sample types.",
        "handle": "/products/quick-dna-viral-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3015.jpg",
        "generalIndex": "30",
        "id": "quick-dna-viral-kit",
        "tags": [
          "blood",
          "cells",
          "biological-fluids",
          "swabs-and-saliva",
          "virus",
          "spin-columns",
          "microbial-environmental",
          "hmw-dna"
        ],
        "filters": []
      },
      "Quick-DNA Viral 96 Kit": {
        "title": "<i>Quick</i>-DNA Viral 96 Kit",
        "catalogNumbers": "D3017, D3018",
        "description": "High-throughput extraction of highly concentrated ultra-pure viral DNA from a wide range of sample types.",
        "handle": "/products/quick-dna-viral-96-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3017.jpg",
        "generalIndex": "31",
        "id": "quick-dna-viral-96-kit",
        "tags": [
          "blood",
          "cells",
          "biological-fluids",
          "swabs-and-saliva",
          "virus",
          "high-throughput",
          "automated-high-throughput",
          "96-well-plate",
          "microbial-environmental",
          "hmw-dna"
        ],
        "filters": [
          // {
          //   "filter": "high-throughput",
          //   "index": 10
          // }
        ]
      },
      "Quick-DNA Urine Kit": {
        "title": "<i>Quick</i>-DNA Urine Kit",
        "catalogNumbers": "D3061",
        "description": "Easily extract high quality cell-free or cellular DNA from up to 40 ml of urine using spin-column purification.",
        "handle": "/products/quick-dna-urine-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3061.jpg",
        "generalIndex": "29",
        "id": "quick-dna-urine-kit",
        "tags": [
          "urine",
          "virus",
          "cell-free-dna",
          "quick-dna-extraction-kits",
          "proteinase-k-included",
          "high-sample-input",
          "spin-columns"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 6
          // },
          {
            "filter": "urine",
            "index": 1
          }
        ]
      },
      "<i>Quick</i>-DNA FFPE Miniprep": {
        "title": "<i>Quick</i>-DNA FFPE Miniprep Kit",
        "catalogNumbers": "D3067",
        "description": "Isolate ultra-pure DNA from FFPE tissue with an optimized and fast spin-column protocol.",
        "handle": "/products/quick-dna-ffpe-miniprep",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3067.jpg",
        "generalIndex": "23",
        "id": "quick-dna-ffpe-miniprep",
        "tags": [
          // "ffpe-tissue",
          "ffpe",
          "proteinase-k-included",
          "quick-dna-extraction-kits",
          "spin-columns"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 7
          // }
        ]
      },
      "Quick-cfDNA Serum & Plasma Kit": {
        "title": "<i>Quick</i>-cfDNA Serum & Plasma Kit",
        "catalogNumbers": "D4076",
        "description": "Reliably extract high-quality circulating cell-free DNA from serum, plasma, amniotic fluid, cerebrospinal fluid (CSF), and saliva.",
        "handle": "/products/quick-cfdna-serum-plasma-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4076.jpg",
        "generalIndex": "32",
        "id": "quick-cfdna-serum-plasma-kit",
        "tags": [
          "biological-fluids",
          "swabs-and-saliva",
          "proteinase-k-included",
          "cell-free-dna",
          "spin-columns"
        ],
        "filters": [
          {
            "filter": "cell-free-dna",
            "index": 1
          }
        ]
      },
      "Pinpoint Slide DNA Isolation": {
        "title": "Pinpoint Slide DNA Isolation System",
        "catalogNumbers": "D3001",
        "description": "Streamlined isolation of ultra-pure DNA from specific regions of fresh and FFPE tissue slides.",
        "handle": "/products/pinpoint-slide-dna-isolation-system",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D3001.jpg",
        "generalIndex": "36",
        "id": "pinpoint-slide-dna-isolation-system",
        "tags": [
          "slide",
          // "ffpe-tissue",
          "ffpe",
          "proteinase-k-included",
          "quick-dna-extraction-kits",
          "spin-columns"
        ],
        "filters": [
          // {
          //   "filter": "quick-dna-extraction-kits",
          //   "index": 11
          // }
        ]
      },
      "HostZero Microbial DNA Kit": {
        "title": "HostZero Microbial DNA Kit",
        "catalogNumbers": "D4310",
        "description": "Effective host DNA depletion and total microbial DNA isolation from mammalian samples using a simple spin-column process.",
        "handle": "/products/hostzero-microbial-dna-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4310.jpg",
        "generalIndex": "37",
        "id": "hostzero-microbial-dna-kit",
        "tags": [
          "bacteria",
          "blood",
          "tissue",
          "biological-fluids",
          "swabs-and-saliva",
          "yeast-fungi",
          "proteinase-k-included",
          "physical-lysis",
          "spin-columns",
          "certified-low-bioburden",
          "host-dna-depletion",
          "microbiome-metagenome-analysis",
          "physical-lysis",
          "microbial-environmental"
        ],
        "filters": []
      },
      "YeaStar Genomic DNA Kit": {
        "title": "YeaStar Genomic DNA Kit",
        "catalogNumbers": "D2002",
        "description": "Reliable and efficient isolation of genomic DNA from a broad spectrum of fungal species using Zymolyase.",
        "handle": "/products/yeastar-genomic-dna-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D2002.jpg",
        "generalIndex": "38",
        "id": "yeastar-genomic-dna-kit",
        "tags": [
          "microbial-cultures",
          "yeast-fungi",
          "spin-columns",
          "microbial-environmental",
          "zymolyase-included"
        ],
        "filters": []
      },
      "EZ Nucleosomal DNA Prep Kit": {
        "title": "EZ Nucleosomal DNA Prep Kit",
        "catalogNumbers": "D5220",
        "description": "Streamlined and optimized method for isolating nucleosome-associated DNA.",
        "handle": "/products/ez-nucleosomal-dna-prep-kit",
        "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D5220.jpg",
        "generalIndex": "39",
        "id": "ez-nucleosomal-dna-prep-kit",
        "tags": [
          "microbial-cultures",
          "cells",
          "yeast-fungi",
          "nucleosomal-dna-isolation",
          "spin-columns"
        ],
        "filters": []
      },
      // "Quick-DNA/RNA Water Kit": {
      //   "title": "<i>Quick</i>-DNA/RNA Water Kit",
      //   "catalogNumbers": "R2044",
      //   "description": "The <i>Quick</i>-DNA/RNA Water Kit efficiently isolates inhibitor-free nucleic acids from large water samples, ideal for sensitive applications like ddPCR, RT-qPCR, and NGS.",
      //   "handle": "/products/quick-dna-rna-water-kit",
      //   "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna_rna_co_extraction/R2044.webp",
      //   "generalIndex": "998",
      //   "id": "quick-dna-rna-water-kit",
      //   "tags": [
      //     "bacteria",
      //     "soil-and-water",
      //     "virus",
      //     "yeast-fungi",
      //     "microbiome-metagenome-analysis",
      //     "physical-lysis",
      //     "total-nucleic-acid-dna-rna-purification",
      //     "spin-columns",
      //     "certified-low-bioburden",
      //     "high-sample-input",
      //     "microbial-environmental"
      //   ],
      //   "filters": []
      // }
    }
  }